import styles from "./SearchQuery.module.scss";
import { Clear, Search } from "../../assets/icons";

interface SearchQueryProps {
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;
  onClear?: () => void;
  placeholder?: string;
  error?: string | null;
  isLoading?: boolean;
}

const SearchQuery: React.FC<SearchQueryProps> = ({
  searchQuery,
  onSearchQueryChange,
  onClear,
  placeholder = "Поиск сервера",
  isLoading,
}) => {
  const hasValue = searchQuery.trim().length > 0;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearchQueryChange(e.target.value);
  };

  const handleClear = () => {
    onSearchQueryChange("");
    onClear?.();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Escape") {
      handleClear();
    }
  };

  return (
    <div className={styles.searchQuery}>
      <div className={styles.searchWrapper}>
        <input
          type="text"
          placeholder={placeholder}
          value={searchQuery}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          className={styles.searchInput}
          disabled={isLoading}
        />

        {hasValue && (
          <button
            type="button"
            onClick={handleClear}
            className={styles.clearBtn}
            aria-label="Очистить поиск"
          >
            <Clear size={20} />
          </button>
        )}
      </div>

      <div className={styles.searchIcon}>
        {isLoading ? <div className={styles.spinner} /> : <Search size={20} />}
      </div>
    </div>
  );
};

export default SearchQuery;
